import React, { useEffect } from 'react';
import {
  Grid,
  Typography,
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';
import { DefaultButton, colors, LottieAnimation } from 'design-system';
import { Quotation } from 'data-layer-cr/dist/models';
import trackConfirmationEvent from '../trackConfirmationEvent';
import { inspectionSuccessAnimation } from '../../../../lottieFiles';

type Props = {
  requesting: boolean;
  onEmissionRequested: () => void;
  onBrokerActionRequested: () => void;
  quotationCreator: string;
  quotation: Quotation;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    image: {
      marginTop: -60,
    },
    container: {
      padding: `0 ${theme.spacing(2)}px`,
      marginBottom: 10,
    },
    buttonContainer: {
      width: 300,
      display: 'inline-block',
    },
    instructions: {
      display: 'inline',
      color: colors.madison,
      fontSize: 14,
    },
  }),
);

const Confirmation = ({
  onEmissionRequested,
  requesting,
  onBrokerActionRequested,
  quotationCreator,
  quotation,
}: Props): JSX.Element => {
  const classes = useStyles();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const quotationRole = quotationCreator === 'ASE' ? 'corredor' : 'ejecutivo';
  return (
    <>
      {!requesting && (
        <div className={classes.container}>
          <Grid data-testid="content" container spacing={2}>
            <Grid item xs={12} container justifyContent="center">
              <Typography variant="h2" align="center">
                ¡Gracias por realizar la inspección!
              </Typography>
            </Grid>
            <Grid item xs={12} container justifyContent="center">
              <LottieAnimation animationJson={inspectionSuccessAnimation} />
            </Grid>
            <Grid item xs={12} container justifyContent="center">
              <Typography style={{ fontWeight: 600 }}>
                ¿Deseas obtener tu póliza más rápido?
              </Typography>
            </Grid>
            <Grid item xs={12} container justifyContent="center">
              <div className={classes.buttonContainer}>
                <DefaultButton
                  id="sales-web-inspection-button-clientrequest"
                  data-testid="emission-request-button"
                  onClick={(): void => {
                    trackConfirmationEvent(
                      'CONTINÚA CON LA EMISIÓN',
                      quotation,
                    );
                    onEmissionRequested();
                  }}
                  fullWidth
                >
                  CONTINÚA CON LA EMISIÓN
                </DefaultButton>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              container
              justifyContent="center"
              direction="column"
            >
              <Typography variant="caption" align="center">
                o puedes notificarle a tu {quotationRole} para{' '}
              </Typography>
              <Typography variant="caption" align="center">
                que realice la emisión de tu póliza.
              </Typography>
            </Grid>
            <Grid item xs={12} container justifyContent="center">
              <div className={classes.buttonContainer}>
                <DefaultButton
                  id="sales-web-inspection-button-brokerrequest"
                  data-testid="broker-request-button"
                  onClick={(): void => {
                    trackConfirmationEvent(
                      `Notificar a mi ${quotationRole}`,
                      quotation,
                    );
                    onBrokerActionRequested();
                  }}
                  variant="outlined"
                  fullWidth
                >
                  Notificar a mi {quotationRole}
                </DefaultButton>
              </div>
            </Grid>
          </Grid>
        </div>
      )}
    </>
  );
};

export default Confirmation;
